<template>
  <div class="home-view">
    <keep-alive>
      <router-view class="home-route-view" />
    </keep-alive>
    <Tabbars ref="tabView" v-model="currentTab" :tabs="tabs" />
  </div>
</template>

<script>
import Tabbars from "./components/Tabbars";

export default {
  components: {
    Tabbars
  },
  data() {
    return {
      currentTab: 0,
      show: true
    };
  },
  computed: {
    tabs() {
      return [
        {
          title: "门诊",
          route: "/home",
          iconSelected: require("@/assets/icon_home_tab_outpatient_selected.png"),
          iconUnSelected: require("@/assets/icon_home_tab_outpatient_unselected.png")
        },
        {
          title: "住院",
          route: "/inpatient",
          iconSelected: require("@/assets/icon_home_tab_inpatient_selected.png"),
          iconUnSelected: require("@/assets/icon_home_tab_inpatient_unselected.png")
        },
        /**{
          title: "体检",
          route: "/examination",
          iconSelected: require("@/assets/icon_home_tab_examination_selected.png"),
          iconUnSelected: require("@/assets/icon_home_tab_examination_unselected.png")
        },*/
        {
          title: "我的",
          route: `/mine?type=${
            this.currentTab === 1 ? "inpatient" : "outpatient"
          }`,
          iconSelected: require("@/assets/icon_home_tab_mine_selected.png"),
          iconUnSelected: require("@/assets/icon_home_tab_mine_unselected.png")
        }
      ];
    }
  },
  watch: {
    $route(to) {
      if (to.name === "outpatient") {
        this.$refs.tabView.setCurrentTab(0);
      }
    }
  },
  created() {
    const { path } = this.$route;
    for (var i in this.tabs) {
      if (this.tabs[i].route.split("?")[0] === path) {
        this.currentTab = parseInt(i);
        break;
      }
    }
  },
  methods: {}
};
</script>

<style lang="less" scoped>
.home-view {
  background: #efeff4;
}
.home-route-view {
  margin-bottom: @tabbar-height;
}
</style>
